import { IEntity } from "@interfaces/entity";

export class MasterUserOfCustomer implements IEntity {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  fullName: string;
  gender: string;
  street: string;
  houseNumber: string;
  postcode: string;
  city: string;
  phone: string;
  registrationDate: Date;

  customerId: number;

  entityName = "MasterUserOfCustomer";

  getPrimaryKey() {
    return this.id;
  }

  updateValues(formValue: Partial<MasterUserOfCustomer>) {
    Object.assign(this, formValue);
  }

}
